export default __webpack_public_path__ + "static/media/mb-logo.00108b23.svg";